<template>
	<div class="col-sm-12 col-lg-2">
		<div class="filter__wrapper" :class="{open: 'breed' === showList, close: 'breed' !== showList}">
			<input type="text"
				   :placeholder="$t('filters.breeds')"
				   class="filter"
				   :class="{open: 'breed' === showList, close: 'breed' !== showList}"
				   @click="updateShowList('breed')"
				   @input="showList = 'breed'"
				   v-model="searchByBreed"
			>
			<ul v-show="'breed' === showList"
				class="filter__list"
			>

				<li v-for="item in breedsList"
					class="filter__list-item"
				>
					<label class="filter__label">{{item.name}}
						<input class="filter__input"
							   type="checkbox"
							   :value="item"
							   :checked="$store.getters.isBreedActive(item)"
							   @change="changeFilters($event, item)"
						>
						<span class="filter__checkbox"></span>
					</label>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapMutations } from 'vuex'

	export default {
		data () {
			return {
				showList: '',
				searchByBreed: ''
			}
		},
		methods: {
			...mapActions(['fetchEvents', 'fetchBreeds']),
			...mapMutations(['addBreed']),
			changeFilters (e, item) {
				if (e.target.checked) {
					this.addBreed(item.id)
					this.fetchEvents()
				} else {
					this.$store.commit('removeBreed', item.id)
					this.fetchEvents()
				}
			},
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			}
		},
		computed: {
			breedsList () {
				const inputTest = person => {
					const regExp = new RegExp('^' + this.searchByBreed, 'i')
					return regExp.test(person.name)
				}
				return this.$store.state.events.breeds.filter(inputTest)
			}
		},
		created () {
			window.addEventListener('click', this.closeFlitersLists)
			this.fetchBreeds()
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";
	@import "../../../styles/filters.scss";
</style>



// WEBPACK FOOTER //
// src/components/EventsList/Filters/BreedsFilterComponent.vue